/**
 * WordPress Dependencies
 */
import { __ } from "@wordpress/i18n";
import { addFilter } from "@wordpress/hooks";
import { assign, isEmpty } from "lodash";
import { createHigherOrderComponent } from "@wordpress/compose";
/**
 * Custom Imports
 */
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";

/**
 * Add new attributes to the block
 */
const addAttributes = (props) => {
	const { attributes } = props;
	if (isEmpty(attributes) || props.name !== "core/gallery") {
		return props;
	}
	assign(
		props.attributes,
		{
			...attributes,
			ghubGalleryLightbox: {
				type: "boolean",
				default: false,
			},
			ghubLightboxOpenEffect: {
				type: "string",
				default: "none",
			},
			ghubLightboxSlideEffect: {
				type: "string",
				default: "none",
			},
			ghubLightboxKeyboardNavigation: {
				type: "boolean",
				default: false,
			},
			ghubLightboxCloseOnOutsideClick: {
				type: "boolean",
				default: false,
			},
			ghubLightboxZoomAble: {
				type: "boolean",
				default: false,
			},
			ghubLightboxDraggable: {
				type: "boolean",
				default: false,
			},
			ghubLightboxLoop: {
				type: "boolean",
				default: false,
			},
			ghubOverlayColor: {
				type: "string",
				default: "#000000",
			},
		},
		{}
	);

	return props;
};

const withAdvanceControls = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		const { name } = props;

		if (name !== "core/gallery") {
			return <BlockEdit {...props} />;
		}

		return (
			<>
				<BlockEdit {...props} />
				<Inspector {...props} />
			</>
		);
	};
}, "withAdvanceControls");

const withBlockWrapper = createHigherOrderComponent((BlockListBlock) => {
	return (props) => {
		const { attributes } = props;
		if (props.name !== "core/gallery") {
			return <BlockListBlock {...props} />;
		}
		return <BlockListBlock {...props} />;
	};
}, "withBlockWrapper");

addFilter(
	"editor.BlockEdit",
	"ghub-gallery-lightbox/with-advance-controls",
	withAdvanceControls
);
addFilter(
	"blocks.registerBlockType",
	"ghub-gallery-lightbox/add-attributes",
	addAttributes
);
addFilter(
	"editor.BlockListBlock",
	"ghub-gallery-lightbox/with-block-wrapper",
	withBlockWrapper
);
